import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app.component';
import { RouterModule } from '@angular/router';
import { NgxIndexedDBModule, DBConfig } from 'ngx-indexed-db';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { AppRoutingModule } from './app-routing.module';
import { providePrimeNG } from 'primeng/config';
import Lara from '@primeuix/themes/lara';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { InfoModal } from './shared/components/info-modal/info-modal';
import { AuthInterceptor } from './shared/interceptor/auth.interceptor';
import { TenantInterceptor } from './shared/interceptor/tenant.interceptor';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';


export const dbConfig: DBConfig = {
  name: 'FormsDB',
  version: 1,
  objectStoresMeta: [



    /* =========================
       DEPARTMENT FORMS
       Stores forms associated with a department
    ========================== */


    {
      store: 'departmentFormsNames',
      storeConfig: { keyPath: 'apiUrl', autoIncrement: false },
      storeSchema: [
        { name: 'apiUrl', keypath: 'apiUrl', options: { unique: true } },
        { name: 'departmentFormsData', keypath: 'departmentFormsData', options: { unique: false } }
      ]
    },

    /* =========================
       FORM TEMPLATES
       Stores templates for each form
    ========================== */
    {
      store: 'departmentFormTemplate',
      storeConfig: { keyPath: 'departmentFormID', autoIncrement: false },
      storeSchema: [
        { name: 'departmentFormID', keypath: 'departmentFormID', options: { unique: true } },
        { name: 'templateData', keypath: 'templateData', options: { unique: false } } // full template JSON
      ]
    },

    /* =========================
       OFFLINE FORM SUBMISSIONS
       Stores completed forms offline
    ========================== */
    {
      store: 'offlineForms',
      storeConfig: { keyPath: 'id', autoIncrement: false },
      storeSchema: [
        { name: 'id', keypath: 'id', options: { unique: true } },
        { name: 'userForm', keypath: 'userForm', options: { unique: false } },
        { name: 'signatureBlobs', keypath: 'signatureBlobs', options: { unique: false } },
        { name: 'timestamp', keypath: 'timestamp', options: { unique: false } }
      ]
    },

  ]
};


@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    HttpClientModule,
    RouterModule,
    ToastModule,
    InfoModal,
    NgxIndexedDBModule.forRoot(dbConfig),
    ServiceWorkerModule.register('ngsw-worker.js', {
      // Only register on dev/staging deploys; never on localhost (local run)
      enabled: (environment as { enableServiceWorker?: boolean }).enableServiceWorker === true &&
        typeof window !== 'undefined' && !/^localhost$|^127\.0\.0\.1$/.test(window.location?.hostname ?? ''),
      registrationStrategy: 'registerWhenStable:30000'
    }),
  ],
  declarations: [
    AppComponent,
  ],


  providers: [
    provideAnimationsAsync(),
    MessageService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TenantInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },

    providePrimeNG({
      theme: {
        preset: Lara,
        options: {
          darkModeSelector: '.my-dark-theme'
          // cssLayer: true
        }
      }
    })
  ],

  bootstrap: [AppComponent]

})
export class AppModule { }
